export const enum RoomGrouping {
  BY_CATEGORY = 'BY_CATEGORY',
  BY_TYPE = 'BY_TYPE',
  NONE = 'NONE'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/RateRuleParameters/RoomGrouping.ts